import { render } from "./TaskPriority.vue?vue&type=template&id=bacf5a7a"
import script from "./TaskPriority.vue?vue&type=script&lang=js"
export * from "./TaskPriority.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__